import React from "react";
import classNames from "classnames";
import { Svg, type SvgProps } from "@shared/ui/svg";
import "./Icon.scss";

type IconSize = "sm" | "md" | "lg" | (string & {});

interface IconStyle extends React.CSSProperties {
    "--icon-size"?: string;
}

/** Пропсы {@link Icon}. */
export interface IconProps extends SvgProps {
    /**
     * Цвет иконки через `currentColor`.
     * @note Работает для SVG, где `fill`/`stroke` завязаны на `currentColor`.
     */
    currentColor?: string;
    /**
     * Размер иконки: пресеты `sm`/`md`/`lg` или CSS-значение.
     * @default "md"
     */
    size?: IconSize;
}

const presetSizeClassName: Record<"sm" | "md" | "lg", string> = {
    sm: "shared_icon--sm",
    md: "shared_icon--md",
    lg: "shared_icon--lg",
};

const isPresetSize = (size: IconSize): size is "sm" | "md" | "lg" => size in presetSizeClassName;

/**
 * Универсальная SVG-иконка для shared UI.
 */
export const Icon: React.FC<IconProps> = ({ className, currentColor, size = "md", style, alt = "", ...svgProps }) => {
    const iconStyle: IconStyle = {
        ...style,
        color: currentColor,
        "--icon-size": isPresetSize(size) ? undefined : size,
    };

    return (
        <Svg
            {...svgProps}
            alt={alt}
            aria-hidden={alt.length === 0 ? true : undefined}
            className={classNames("shared_icon", isPresetSize(size) && presetSizeClassName[size], className)}
            style={iconStyle}
        />
    );
};
